import { getProviderNameForBillRecord } from '@demandproai/shared';

export const PROVIDER_NAME_ERROR = {
  REQUIRED: 'Provider name is required',
  DUPLICATE: 'Provider Name Already Exists',
};

// Storage collapses bill rows that share a case-insensitive provider name and sums their
// totals, so a blank or duplicate name would silently merge two bills into one.
export const validateMedicalBillProviderName = ({ value, records = [], rowIndex }) => {
  const trimmedName = String(value ?? '').trim();

  if (!trimmedName) {
    return { isValid: false, error: PROVIDER_NAME_ERROR.REQUIRED };
  }

  const hasDuplicateName = records.some(
    (record, index) =>
      index !== rowIndex &&
      getProviderNameForBillRecord(record).trim().toLowerCase() === trimmedName.toLowerCase()
  );

  if (hasDuplicateName) {
    return { isValid: false, error: PROVIDER_NAME_ERROR.DUPLICATE };
  }

  return { isValid: true, value: trimmedName };
};
